import React from 'react';
import {BarElement, CategoryScale, Chart as ChartJS, LinearScale, Tooltip,} from 'chart.js';
import {Typography,} from '@mui/material';
import './CorporateRisk.css';
import HeatBar from "./HeatBar";
import ScoreCard from "./ScoreCard";
import TextCard from "./TextCard";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

const CorporateRisk = (company, chartRef, isLoading) => {
    const corporateRisk = corporateRiskParser(company, chartRef);
    return (
        <div id="content" className={"bg-black"}
             style={{
                 width: '100%', margin: "10px auto 0 auto", padding: "0 15px", fontSize: "1rem", fontWeight: "500",
                 lineHeight: "1.5", height: "20%"
             }}>
            {isLoading && (<Typography variant="h5" className="gray-text">Loading...</Typography>)}
            {!isLoading && (corporateRisk)}
        </div>
    );
}

const corporateRiskParser = (company, chartRef) => {
    return (
        <>
            <table className={"table table-dark"} style={{backgroundColor: "black"}}>
                <tbody>
                <tr>
                    <td width={'25%'} style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">Corporate Score</Typography>
                    </td>
                    <td width={'25%'}>
                        <ScoreCard title='Risk Score' content={`${company.risk_score}/${company.max_score}`}/>
                    </td>
               </tr>
                <tr>
                    <td style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">Rating</Typography>
                    </td>
                    <td>
                        <HeatBar label={'Risk'} score={company.risk_score} rating={company.risk_rating}
                                 chartRef={chartRef}/>
                    </td>
               </tr>
                <tr>
                    <td style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">Rating Relative to Peers</Typography>
                    </td>
                    <td>
                        <ScoreCard title={company.risk_rating_relative}
                                   content={`Average of SP500 Energy Sector is ${company.risk_peer_avg}`}/>
                    </td>
               </tr>
                <tr>
                    <td style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">Percentile in Energy SP500</Typography>
                    </td>
                    <td style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">50</Typography>
                    </td>
                </tr>
                <tr>
                    <td style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">Percentile in SP500</Typography>
                    </td>
                    <td style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">34</Typography>
                    </td>
                </tr>
                <tr>
                    <td colSpan={2}>
                        <TextCard
                            content={`The Risk Score describes a corporation's vulnerability to physical climate risk, taking into account both hazard exposure and resilient capabilities. Higher Risk Scores reflect greater exposure, which can be partially offset by high resilience. The Risk equation follows the structure: Risk = Exposure - Resilience + Baseline, where each component serves a specific purpose: 1) a non-linear exposure term which reflects higher damages for rare events, 2) a linear resilience term which reduces risk as resilience increases, and 3) a constant baseline risk to highlight that no asset is completely risk-free`}/>
                    </td>
               </tr>
                </tbody>
            </table>
        </>
    )
}

export default CorporateRisk;
